import { useState, useRef, useEffect } from "react";
import BannerSection from "../../Components/BannerSection";
import RoundCard from "../../Components/RoundCard";
import FixturesAndResults from "../../Components/FixturesAndResults";
import axios from "axios";
import { useNavigate } from "react-router";
import { refreshTokenV2 } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import FixturesAndResultsHome from "../../Components/FixtureAndResultsHome";
import { baseURL } from "../../services/axiosConfig";
import Champions from "../../Components/Champions";
import Navbar from "../RoundToJoin/navbar";

import {
  fixtureOpen,
  updateV2Fixtures,
} from "../RoundToJoin/roundToJoin.slice";
import FixturePopup from "../../popups/FixturePopup";
import TokenRedeemPopUp from "../../popups/tokenRedeemPopUp";
import PaymentComponent from "./PaymentComponent";
import MBMEPayment from "./PaymentComponent";
import { create_hmac_hash } from "./createSortedString";
import PaymentForm from "./Payment";
import { updateMypot, updateRoundToJoin } from "./dashboard.slice";
import ConfirmPopup from "../../popups/PickConfrimPopup";
import useWebSocket from "../../websoket/websocket";
import { FooterTab, MobileFooter } from "../../../Components/GreenHome/Footer";
import Footer from "../../Components/Footer";

// The ProfileDropdown component has been moved to a separate file and is imported via the Navbar component

// Circular Loader Component
const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Rounds Loading...</div>
  </div>
);

export default function V2Dashboard() {
  const socketRef = useWebSocket("/ws/joinpot/pot/");
  // States for navigation and UI
  const { redeemPopup } = useSelector((state) => state.roundToJoin);
  const [selectedNav, setSelectedNav] = useState("Home");
  const [selectedSubNav, setSelectedSubNav] = useState("Home");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // States for fixtures and API data
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Safely get the token - Modified to handle null/undefined checks
  const token = localStorage.getItem("access_token");
  const [fixturesData, setFixturesData] = useState([]);

  const { myRounds, roundsToJoin } = useSelector(
    (state) => state.dashboard.potInfo
  );

  const myPickHandler = (id) => { };

  const fetchFixtures = async (roundId, matchWeeks, pickId, component) => {
    // MODIFIED: If no token exists, skip fetching private data to avoid 401 redirect
    if (!token || token === "null" || token === "undefined") return;

    try {
      if (component === "mypot") {
        const res = await axios.get(
          `${baseURL}/pot/pickmatchpredictions/${matchWeeks}?pick=${pickId}`,
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          }
        );
        dispatch(updateV2Fixtures(res.data));
      } else {
        const res = await axios.get(
          `${baseURL}/pot/fixtures?pot_id=${roundId}&current_matchweek=true`,
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          }
        );
        dispatch(updateV2Fixtures(res.data));
      }
    } catch (error) {
      if (error?.response?.status === 401 && token) {
        refreshTokenV2(dispatch);
      }
    }
  };

 const viewFixtureHandler = (roundId, potInfo, matchWeeks, pickId, component) => {
  const hasToken = token && token !== "null" && token !== "undefined";

  // 🔒 Block ONLY private mypot data
  if (component === "mypot" && !hasToken) {
    window.location.href = "/login";
    return;
  }

  fetchFixtures(roundId, matchWeeks, pickId, component);
  dispatch(fixtureOpen(true));
};


  const getRounds = async (potType) => {
  try {
    setIsLoading(true);

    const headers = {};

    // Only attach token if user is logged in
    if (token && token !== "null" && token !== "undefined") {
      headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }

    const response = await axios.get(
      `${baseURL}/dashboard/rounds/prioritized-retrieve/?type=${potType}`,
      { headers }
    );

    setIsLoading(false);
    return response?.data?.data;
  } catch (error) {
    setIsLoading(false);

    if (error?.response?.status === 401 && token && token !== "null") {
      refreshTokenV2(dispatch);
    }

    console.error("Error fetching rounds:", error);
    return [];
  }
};



 useEffect(() => {
  const activepots = "activepot";
  const newpot = "newpot";

  const fetchRounds = async () => {
    const hasValidToken = token && token !== "null" && token !== "undefined";

    const [myRoundsData, joinRoundsData] = await Promise.all([
      hasValidToken ? getRounds(activepots) : Promise.resolve([]), // My Rounds only for logged users
      getRounds(newpot), // Rounds To Join for everyone
    ]);

    dispatch(updateMypot(myRoundsData || []));
    dispatch(updateRoundToJoin(joinRoundsData || []));
  };

  fetchRounds();
}, [token]);


  const [fixtures, setFixtures] = useState([]);

  const [pots, setPots] = useState([]);

  useEffect(() => {
    if (roundsToJoin[0]?.pots?.length) {
      setPots(roundsToJoin[0].pots.slice(0, 4));
    }
  }, [roundsToJoin]);


  const sendTestMessage = () => {
    if (WebSocket.OPEN) {
      console.log("WebSocket is open");
    } else {
      console.log("WebSocket is not open");
    }
  };

  useEffect(() => {
    sendTestMessage()
  }, [])


  // Navigation items are now defined in the Navbar component

  const SmallDashedDivider = () => (
    <div className="w-full flex flex-row justify-center items-center my-8">
      <div className="w-full flex flex-row">
        {Array.from({ length: 72 }).map((_, idx) => (
          <div
            key={idx}
            className="h-[2px] w-6 bg-[#00000050] opacity-50 rounded-full"
            style={{
              opacity: idx % 2 === 0 ? 1 : 0,
            }}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div
      className={
        "font-interFont w-full bg-[#082642] min-h-screen  border-b border-b-white"
      }
    >
      {/* <ConfirmPopup /> */}
      <div className="fixed top-0 left-0 right-0 z-50  border-b border-[#1A3D5D]">
        {redeemPopup && <TokenRedeemPopUp />}
        <Navbar
          setDropdownOpen={setDropdownOpen}
          setSelectedNav={setSelectedNav}
          selectedNav={selectedNav}
          setMobileMenuOpen={setMobileMenuOpen}
          setDropdownPos={setDropdownPos}
          dropdownPos={dropdownPos}
          dropdownOpen={dropdownOpen}
          mobileMenuOpen={mobileMenuOpen}
          setOtherMenusOpen={setOtherMenusOpen}
          otherMenusOpen={otherMenusOpen}
        />
        {/* <MBMEPayment uid={"122"} apiKey={"6Ic1mdkVLhsC0GwuzxseOzZFE9FbSjKuHmjcXjD9nUc="} /> */}
        {/* <div id="payment-container"></div> */}
        {/* <div id="payment-container"></div> */}
        {/* <PaymentForm /> */}
      </div>
      <div className="pt-16 w-full min-h-screen">
        {/* Scrollable Navigation Sub-Bar */}
        <div className="w-full bg-gradient-to-r from-[#007FFF] to-[#00C05B] py-4 px-2.5 overflow-x-auto scrollbar-hide">
          <div className="flex items-center gap-2 px-3 min-w-min whitespace-nowrap">
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${selectedSubNav === "Home"
                ? "bg-white text-black py-1.5"
                : "border border-[#FFFFFF70] text-[#FFFFFF70]"
                }`}
              onClick={() => setSelectedSubNav("Home")}
            >
              Home
            </button>
            
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${selectedSubNav === "Fixtures & Results"
                ? "bg-white text-black py-1.5"
                : "border border-[#FFFFFF70] text-[#FFFFFF70]"
                }`}
              onClick={() => setSelectedSubNav("Fixtures & Results")}
            >
              Fixtures & Results
            </button>
            
            
            <button
              className={`px-3 py-1.5 rounded-full font-archivo font-semibold text-xs md:text-[14px] ${selectedSubNav === "Champions"
                ? "bg-white text-black py-1.5"
                : "border border-[#FFFFFF70] text-[#FFFFFF70]"
                }`}
              onClick={() => setSelectedSubNav("Champions")}
            >
              Champions
            </button>
            
          </div>
        </div>

        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}</style>

        {/* Main Content Switcher */}
        {selectedSubNav === "Fixtures & Results" ? (
          <FixturesAndResults />
        ) : selectedSubNav === "Champions" ? (
          <Champions />
        ) : (
          <>
            {/* Banner */}

            <BannerSection />
            <FixturePopup
              // isOpen={isOpen}
              // setIsOpen={setIsOpen}
              myPickHandler={myPickHandler}
              fixturesData={fixturesData}
              componentType="fixtures"
            />
            {isLoading ? (
              <CircularLoader />
            ) : (
              <>
              
<div className="w-full sm:w-[95%] mx-auto bg-white p-2 sm:p-4 md:p-8 rounded mt-2">

  {/* ================= ROUNDS TO JOIN (PUBLIC) ================= */}
  <div>
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-xl font-archivo font-bold">Rounds To Join</h3>

      {roundsToJoin?.length > 0 &&
        roundsToJoin[0]?.pots?.length > 0 && (
          <button
            className="bg-[#0081F8] text-white text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-full font-medium"
            onClick={() => navigate("/rounds", { state: { myRound: false } })}
          >
            View All
          </button>
        )}
    </div>

    <div
      className="flex overflow-x-auto flex-nowrap gap-4 sm:gap-6 scrollbar-hide pb-2 sm:pb-4"
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      {roundsToJoin?.length === 0 ||
      !roundsToJoin[0]?.pots?.length ? (
        <div className="text-gray-400 text-center w-full py-8">
          No Rounds to Join Found.
        </div>
      ) : (
        roundsToJoin[0]?.pots?.slice(0, 4)?.map((r) => (
          <RoundCard
            key={r.id}
            round={r.id}
            potInfo={r}
            logo={r.season_logo}
            league={r.season_name}
            currency={r.pot_currency}
            year={r.season_year}
            amount={r.pot_value}
            netPotValue={r.net_pot_value}
            filled={r.filled}
            status={r.status}
            timer={r.timer}
            up={r.active_picks_count}
            down={r.lost_picks_count}
            color={r.season_card_color}
            isMyRound={false}
            endTime={r.last_entry_time}
            round_amount={r.current_pot_value}
            pot_value_percentage={r.pot_amount_percentage}
            btn_color={r.season_btn_color}
            btn_text_color={r.season_btn_text_color}
            progress_color={r.progress_bar_color}
            pot_value={r.pot_value}
            pot_token={r.pot_token}
            viewFixtureHandler={viewFixtureHandler}
            cartType="joinRound"
            gameName={r.game_name}
            gameId={r.game_id}
            
          />
        ))
      )}
    </div>
  </div>

  <SmallDashedDivider />

  {/* ================= MY ROUNDS (LOGIN ONLY) ================= */}
  <div>
    <div className="flex justify-between items-center mb-4 mt-4">
      <h3 className="text-xl font-semibold font-archivo">My Rounds</h3>

      {myRounds?.length > 0 &&
        myRounds[0]?.pots?.length > 0 && (
          <button
            className="bg-[#0081F8] hover:bg-[#006fd4] transition-colors duration-200 text-white text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-full font-medium"
            onClick={() => navigate("/rounds", { state: { myRound: true } })}
          >
            View All
          </button>
        )}
    </div>

    <div
      className="flex overflow-x-auto flex-nowrap gap-4 sm:gap-6 scrollbar-hide pb-2 sm:pb-4"
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      {myRounds?.length === 0 || !myRounds[0]?.pots?.length ? (
        <div className="text-gray-400 text-center w-full py-8">
          {token && token !== "null"
            ? "You haven't participated in any rounds yet."
            : "Login to view your participating rounds."}
        </div>
      ) : (
        myRounds[0]?.pots?.slice(0, 4)?.map((r) => (
          <RoundCard
            key={r.id}
            round={r.id}
            potInfo={r}
            logo={r.season_logo}
            league={r.season_name}
            currency={r.pot_currency}
            year={r.season_year}
            amount={r.pot_value}
            netPotValue={r.net_pot_value}
            filled={r.filled}
            status={r.status}
            timer={r.timer}
            up={r.active_picks_count}
            down={r.lost_picks_count}
            color={r.season_card_color}
            isMyRound={true}
            picks={r.pick_id}
            endTime={r.dead_line?.dead_line}
            lastEntryTime={r.last_entry_time}
            round_amount={r.current_pot_value}
            pot_value_percentage={r.pot_amount_percentage}
            btn_color={r.season_btn_color}
            btn_text_color={r.season_btn_text_color}
            progress_color={r.progress_bar_color}
            pot_value={r.pot_value}
            pot_token={r.pot_token}
            cartType="myRound"
            viewFixtureHandler={viewFixtureHandler}
            gameName={r.game_name}
            gameId={r.game_id}
            
          />
        ))
      )}
    </div>
  </div>

</div>

                
                <FixturesAndResultsHome
                  fixturesData={fixtures}
                  setSelectedSubNav={setSelectedSubNav}
                />
              </>
            )}
          </>
        )}
      </div>
      <div className="pt-3">
        <Footer componnent="rules" />
      </div>
    </div>
  );
}